import {Component, OnInit} from '@angular/core';
import {Banner} from '../../constants/constant-text';
import {DataService} from '../../services/data.service';
import {LocationStrategy} from '@angular/common';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})
export class ResultComponent implements OnInit {

  public passed: boolean;
  public message: string[];

  constructor(private dataService: DataService,
              private locationStrategy: LocationStrategy) {
    this.preventBackButton();
  }

  ngOnInit(): void {
    const result = this.dataService.result;
    this.passed = result.correctAnswers >= result.threshold;
    this.message = this.passed ? this.buildPassMessage() : this.buildFailMessage();
  }

  private buildPassMessage(): string[] {
    const fromUrl = this.dataService.passMessage;
    if (fromUrl) {
      return [fromUrl];
    }
    return Banner.RESULT_PASSED;
  }

  private buildFailMessage(): string[] {
    const fromUrl = this.dataService.failMessage;
    const threshold = this.dataService.result.threshold.toString();
    if (fromUrl) {
      return [fromUrl.replace(/\{x\}/g, threshold)];
    }
    return [
      Banner.RESULT_FAILED[0].replace('{threshold}', threshold),
      Banner.RESULT_FAILED[1]
    ];
  }

  preventBackButton(): void {
    history.pushState(null, null, location.href);
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, location.href);
    });
  }
}
